import $ from 'jquery';
import 'handlebarsHelpers';
import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';
import 'bootstrap';

import {
    addUserGlobalEntityStartTrack
} from '../utils/SnowplowUtils';

import FooterView from 'web-common/scripts/views/FooterView';
import FeatureToggleUtils from 'FeatureToggleUtils';

import Global from 'models/Global';
import Me from 'models/Me';
import Event from 'models/Event';
import WebSocket from 'models/WebSocket';
import Analytics from 'models/Analytics';
import SiteConf from 'models/SiteConf';
import AuthView from 'views/AuthView';
import NavigationView from 'views/NavigationView';
import {getAccessToken} from '../AuthToken';
import { loadCustomCode } from '../CustomCode';

var MainBaseView = Backbone.View.extend({

    initialize: async function(options) {
        _.bindAll(this, 'receivedMessage');

        options = options || {};
        this.bootstrapData = options.bootstrapData;
        this.iOS = ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i)));
        this.android = navigator.userAgent.match(/Android/i);
        this.nextUrl = options.bootstrapData.nextUrl;
        this.listenTo(Backbone, 'set-scrolling', this.setScrollingEnabled);
        this.listenTo(Backbone, 'scroll-to-element', this.scrollToElement);

        this.webSocket = new WebSocket();

        Global.set('eventId', this.bootstrapData.eventID);
        Global.set('isWidget', this.bootstrapData.isWidget);
        Global.set('registrationVersion', this.bootstrapData.registrationVersion);
        Global.set('registrationVersionVariant', this.bootstrapData.registrationVersionVariant);
        Global.set('webSocket', this.webSocket);

        this.cacheHeaderElements();
        this.bindScrolling();

        this.siteConf = new SiteConf(options.bootstrapData.siteConf);

        var getToken = function() {
            return getAccessToken();
        };

        this.me = new Me(_.extend({}, {getToken: getToken}), {parse: true});
        this.event = new Event(this.bootstrapData.event);

        Global.set('me', this.me);
        Global.set('event', this.event);
        Global.set('accountId', this.event.get('account-id'));
        Global.set('uniqueName', this.event.get('unique-name'));
        Global.set('id', this.event.get('id'));
        Global.set('websiteType', this.event.get('websiteType'));
        Global.set('whitelabelPath', this.event.get('whitelabelPath'));
        Global.set('whitelabelWidgetEnabled', this.event.get('whitelabelWidgetEnabled'));
        Global.set('onlyEventDomain', this.event.get('onlyEventDomain'));
        Global.set('internalWebsiteBaseUrl', this.event.getInternalWebsiteBaseUrl());


        this.analytics = new Analytics();

        const navigationView = new NavigationView({
            el: this.$('header'),
            model: this.siteConf,
            me: this.me,
            event: this.event,
            disableInteractions: options.bootstrapData.disableInteractions
        });
        navigationView.render();
        const { primaryEmail, firstName, lastName } = this.me.toJSON();
        const { id: eventId } = this.event.toJSON();
        this.analytics.loadClarity();

        const token = getToken();
        if (token) {
            const that = this;
            this.me.fetch({
                success: (_, me = {}) => {
                    navigationView.render();
                    that.analytics.setClarityIdentity({ eventId, email: primaryEmail, displayName: `${firstName} ${lastName}`});
                    addUserGlobalEntityStartTrack(me);
                }
            });
        }

        new FooterView({
            el: this.$('footer'),
            model: this.siteConf,
            event: this.event,
            disableInteractions: options.bootstrapData.disableInteractions,
            isCookieConsentEnabled: options.bootstrapData.isCookieConsentEnabled
        }).render();

        const isPeopleV2Community = this.event?.get('features')?.communityVersion === 'PEOPLE_V2';
        if ((this.me.isNew() || !this.me.get('isJoined')) && !isPeopleV2Community) {
            new AuthView({
                el: this.$('.auth-view'),
                me: this.me,
                event: this.event
            });
        }

        if (this.me.get('linkedInId')) {
            this.me.verifyLinkedinToken();
        }

        this.listenToMessages();

        this.sendUrlToWhiteLabelDomain();

        this.listenTo(this.siteConf, 'change', this.onConfigurationChange);
        $( document ).ready(function() {
            setTimeout(() => {
                const customCode = loadCustomCode({serverRendered: true});
            }, 1000);
        });
    },

    sendUrlToWhiteLabelDomain: function() {
        if (window.location && window.location.pathname) {
            var path = window.location.pathname;
            var pathArray = path.split('/');
            pathArray.splice(0, 2);
            var urlPath = pathArray.join('/');
            window.parent.postMessage('urlPath:' + urlPath, '*');
        }
    },

    listenToMessages: function() {
        window.addEventListener('message', this.receivedMessage, false);
    },

    receivedMessage: function(e) {
        var json;
        if (e.origin == config.dashboardUrl) {
            if (e.data == 'reload') {
                window.location.reload(false);
                return;
            }
            try {
                json = JSON.parse(e.data);
            } catch (e) {
                json = null;
            }
            json && this.siteConf.set(json);
        }
    },

    backToTop: function() {
        this.scrollToElement(undefined, 0, true);
    },

    cacheHeaderElements: function() {
        this.elements = {
            communityCoverPhoto: this.$('.community-cover-photo'),
            communityCoverPhotoOverlay: this.$('.community-cover-photo-overlay')
        };
    },

    setScrollingEnabled: function(enabled) {
        this.$el.toggleClass('no-scrolling', !enabled);
    },

    scrollToElement: function(jQueryElement, offsetFromTop, animated) {
        var defaultOffset = 0;
        var scrollTop = defaultOffset;
        if (jQueryElement) {
            var jQueryElementTop = jQueryElement.offset().top;
            offsetFromTop = (offsetFromTop === null || offsetFromTop === undefined) ? defaultOffset : offsetFromTop;
            scrollTop = (jQueryElementTop - offsetFromTop);
        }
        animated = (animated === false) ? false : true;
        var css = {
            scrollTop: scrollTop
        };
        animated ? $('html, body').stop().animate(css) : $('html, body').scrollTop(css.scrollTop);
    },

    bindScrolling: function() {
        var windowElement = $(window);
        windowElement.scroll(function() {
            var scrollTop = $(this).scrollTop();
            var offsetFromBottom = 500;
            if (scrollTop + windowElement.height() >= $(document).height() - offsetFromBottom) {
                Backbone.trigger('scrolled-to-bottom');
            }
        });
    },

    setMainView: function(view) {
        this.mainView && this.mainView.remove();
        this.mainView = view;
        if (this.$el.data('server-rendered') !== false) {
            this.mainView.setElement(this.$('.main-view > div'));
            this.$el.data('server-rendered', false);
        } else {
            this.$('.main-view').html(this.mainView.$el);
            setTimeout(() => {
                const customCode = loadCustomCode({serverRendered: false});
            }, 500);
        }
    },

    removeMainView: function() {
        this.mainView && this.mainView.remove();
    }

});

export default MainBaseView;


